<div class="content">
  <h3 class="title1">¡Atención! Archivo bloqueado</h3>
  <p class="title2">
    Al menos uno de los documentos que estás intentando subir está protegido contra la impresión. Si marcas la casilla
    de aceptación, estarás otorgando la autorización necesaria para desbloquear el archivo, lo que permitirá su
    impresión. Además, en caso de que decidas más adelante compartir tu carrito, habilitarás la posibilidad para que
    terceros también impriman dicho archivo.
  </p>

  <ion-item lines="none">
    <ion-label>
      <span>Afirmo tener los permisos necesarios y entiendo las implicaciones de desbloquear el documento. </span>
    </ion-label>
    <ion-checkbox (ionChange)="changeCheck()" slot="start"></ion-checkbox>
  </ion-item>
  <div class="flex flex-col gap-5 md:flex-row">
    <ion-button color="medium-dark" class="title2 w-full md:flex-1" (click)="closeModal('reject')">
      Descartar archivos protegidos
    </ion-button>
    <ion-button color="primary" [disabled]="!check" class="title2 w-full md:flex-1" (click)="closeModal('accept')">
      Aceptar y desbloquear
    </ion-button>
  </div>
</div>
